/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Pricing_ProcessingInputs */

const en_common_pricing_processing = /** @type {(inputs: Common_Pricing_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processing...`)
};

const zh_common_pricing_processing = /** @type {(inputs: Common_Pricing_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`处理中...`)
};

/**
* | output |
* | --- |
* | "Processing..." |
*
* @param {Common_Pricing_ProcessingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_pricing_processing = /** @type {((inputs?: Common_Pricing_ProcessingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Pricing_ProcessingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_pricing_processing(inputs)
	return zh_common_pricing_processing(inputs)
});
export { common_pricing_processing as "common.pricing.processing" }